import AxisCard from "./AxisCard";
import React from "react";
import styled from "styled-components";

const AxisList = ({
                      openStakesView,
                      axis,
                      handleAxisViewOpening,
                      setOpenDeleteModal,
                      setOpenEditModal,
                      setSelectedAxisId,
                      selectedAxisId
                  }) => {


    return (
        <Axis className={`${openStakesView ? "container-active" : ""}`}>
            {axis.map(a => (
                <AxisCard
                    axis={a}
                    key={a.id}
                    handleAxisViewOpening={handleAxisViewOpening}
                    setOpenDeleteModal={setOpenDeleteModal}
                    setOpenEditModal={setOpenEditModal}
                    setSelectedAxisId={setSelectedAxisId}
                    selectedAxisId={selectedAxisId}
                />
            ))}
        </Axis>
    )
}


const Axis = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 1em;
  width: 100%;
`
export default AxisList